import { gql } from 'apollo-boost'

const UNASSIGN_BRAND_GATEWAY_TASK = gql`
  mutation unassignBrandGatewayTask($id: ID!) {
    unassignBrandGatewayTask(id: $id) {
      id
      modifiedDate
    }
  }
`

export default UNASSIGN_BRAND_GATEWAY_TASK
